<template>
    <div id="main">
        <div class="page">
            <loader v-if="isLoading"/>
            <alert-container :messages="msgs" />

            <h1 class="title">{{ empresa }}</h1>
            <nav class="breadcrumb" aria-label="breadcrumbs">
                <ul>
                    <li><a class="a-inativo">{{$t('settings')}}</a></li>
                    <li><a @click="$router.push({ name: 'alertas' })">{{$t('inteligencia-vendas')}}</a></li>
                    <li><a aria-current="page">{{ empresa }}</a></li>
                </ul>
            </nav>

            <div class="configs">
                <div class="titulo-input">
                    <v-input
                        smaller
                        ref="tituloInput"
                        v-model="titulo"
                        :title="'titulo-email'"
                        :maxlength="255"
                        :invalid="titulo.trim().length == 0"
                        :disabled="isSaving"
                    />
                </div>
                <div class="columns">
                    <div class="column is-half is-flex days">
                        <label v-text="$t('dias-da-semana')"/>
                        <div class="day" 
                            v-for="(d, i) in allDays" 
                            :key="i"
                        >
                            <fSwitch :text="$t(d.desc)" :checked="d.checked" @change="changeDay(i, $event)" :disabled="isSaving"/>
                        </div>
                    </div>
                    <div class="column is-half is-flex hours">
                        <label v-text="$t('horas-do-dia')"/>
                        <div class="hour-select">
                            <v-select
                                ref="hourInput"
                                class="smaller"
                                v-model="selectedHours"
                                :options="allHours"
                                :multiple="true"
                                :disabled="isSaving"
                                @input="sortHours"
                            >
                                <template slot="option" slot-scope="option">
                                    {{ getHourString(option.label) }}
                                </template>
                                <template slot="selected-option" slot-scope="option">
                                    {{ getHourString(option.label) }}
                                </template>
                                <template slot="no-options">{{$t('sem-resultados')}}</template>
                            </v-select>
                        </div>
                    </div>
                </div>

                <div class="form-buttons">
                    <button class="delete-btn" type="button" @click="$router.push({ name: 'alertas' })">
                        {{ $t('voltar') }}
                    </button>
                    <button  v-if="permissao.update" class="save-btn" type="button" @click="save()" :disabled="isSaving">
                        {{ $t('salvar') }}
                        <button-loader :isSaving="isSaving" />
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import EmpresaService from "@/services/vendas/empresa/EmpresaService";
import AlertaService from "@/services/AlertaService";
import AlertaValidation from "@/services/validations/AlertaValidation";
import fSwitch from "@/components/shared/form/Switch.vue";
import Message from "@/models/Message";

export default {
    components: {
        fSwitch
    },
    data() {
        return {
            dataService: null,
            filtroService: null,
            validation: null,
            empresa: '',
            idempresa: 0,
            idconfig: 0,
            loadingEmpresa: false,
            allDays: [
                {desc: 'segunda',   checked: false},
                {desc: 'terca',     checked: false},
                {desc: 'quarta',    checked: false},
                {desc: 'quinta',    checked: false},
                {desc: 'sexta',     checked: false},
                {desc: 'sabado',    checked: false},
                {desc: 'domingo',   checked: false},
            ],
            allHours: [0,  1,  2,  3,  4,  5,  6,  7,  8,  9,  10, 11,
                       12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
            selectedHours: [],
            titulo: '',
            isLoading: false,
            isSaving: false,
            msgs: []
        };
    },
    created() {
        this.dataService = new AlertaService(this.$http, this.$router);
        this.empresaService = new EmpresaService(this.$http, this.$router);
        this.validation = new AlertaValidation(this.msgs);

        this.permissao = this.hasPermissionAccess("admin", "inteligencia-vendas", "alertas");
        if ( !this.permissao.read){
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'inteligencia-vendas' }
            });
        } else {

            this.isLoading = true;

            if (this.$route.params.rsocial == undefined) {
                this.empresaService.find(this.$route.params.idempresa)
                    .then(r => {
                        if (r.status != 200) {
                            console.error(`Erro ${r.status} ao carregar empresa ID ${this.$route.params.idempresa}.`, r.message);
                        } else {
                            this.empresa = r.content.rsocial;
                            this.idempresa = r.content.idempresa;
                        }
                    })
                    .catch (e => {
                        console.error(`Erro ${r.status} ao carregar empresa ID ${this.$route.params.idempresa}.`, e);
                    });
            } else {
                this.empresa = this.$route.params.rsocial;
                this.idempresa = this.$route.params.idempresa;
            }

            this.carregarDados();
        }
    },
    methods: {
        carregarDados (reset = false) {
            this.isLoading = true;

            this.dataService.find(this.$route.params.idempresa)
                .then(r => {
                    if (r.status != 200) {
                        console.error(`Erro ${r.status} ao carregar informações de alerta.`, r.message);
                        this.showMessage('error', 'msg-erro-alerta-load');
                    } else if (r.content != null) {
                        let dias = r.content.diassemana != '' ? r.content.diassemana.split(',').map(r => parseInt(r)) : [];
        
                        this.empresa = r.content.empresa.nome;
                        this.idconfig = r.content.idconfigemailvenda;
                        this.titulo = r.content.descricao;
                        this.selectedHours = r.content.horarios != '' ? r.content.horarios.split(',').map(r => parseInt(r)) : [];

                        if (reset) {
                            this.allDays.forEach(e => {
                                e.checked = false;
                            });
                        }
        
                        dias.forEach(d => {
                            this.allDays[d - 1].checked = true;
                        });
                    }
                })
                .catch(e => {
                    console.error('Erro ao carregar informações de alerta', e);
                    this.showMessage('error', 'msg-erro-alerta-load');
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        showMessage (type, message) {
            this.msgs.push(
                new Message(type, message, true)
            );
        },
        changeDay (idx, val) {
            this.allDays[idx].checked = val;
        },
        getHourString (h) {
            return `${h < 10 ? '0' : ''}${h}:00`;
        },
        sortHours () {
            this.selectedHours.sort((a, b) => {
                return a - b;
            });
        },
        clearFields () {
            if (this.$route.params.id == undefined) {
                this.selectedEmpresa = null;
            }

            this.allDays.forEach(d => {
                d.checked = false;
            });

            this.selectedHours = [];
        },
        updateEmpresa (e) {
            this.selectedEmpresa = e;
        },
        save () {
            let config = {
                idconfigemailvenda: this.idconfig != 0 ? this.idconfig : undefined,
                descricao: this.titulo,
                empresa: {
                    idempresa: this.idempresa
                }
            }

            config = this.mapTosave(config);

            config.diassemana = this.stringDays;
            config.horarios = this.stringHours;

            if (this.validation.validate(config, this.$refs)) {
                this.isSaving = true;
                this.dataService.save(config)
                    .then(r => {
                        if (r.status != 200) {
                            console.error(`Erro ${r.status} ao salvar alerta.`, r.message);
                            this.showMessage('error', 'msg-erro-alerta-salvar');
                            this.isSaving = false;
                        } else {
                            this.showMessage('success', 'msg-success-alertas-salvar');
                            this.redirectToList(2);
                        }
                    })
                    .catch(e => {
                        console.error('Erro ao salvar alerta.', e);
                        this.showMessage('error', 'msg-erro-alerta-salvar');
                        this.isSaving = false;
                    });
            }
        },
        redirectToList (time) {
            setTimeout(() => {
                this.$router.push({
                    name: 'alertas',
                });
            }, time * 1000 + 50);
        },
    },
    computed: {
        stringHours: function () {
            let h = '';

            this.selectedHours.forEach(i => {
                h += `${i < 10 ? '0' : ''}${i},`;
            });

            return h.slice(0, -1);
        },
        stringDays: function () {
            let d = '';

            this.allDays.forEach((w, i) => {
                if (w.checked) {
                    d += `${i + 1},`;
                }
            });

            return d.slice(0, -1);
        }
    }
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;
}

.page {
    position: relative;
    padding: 20px;
    background-color: $sovis-white;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    border-radius: 2px;
    margin-bottom: 80px;

    .tab-subtitle {
        text-transform: uppercase;
    }

    .days, .hours {
        margin-top: 10px;
        flex-wrap: wrap;

        label {
            margin-top: 5px;
            width: 100%;
        }

        .day {
            width: 50%;
            height: 30px;
        }

        .hour-select {
            width: 100%;
        }
    }

    .hours {
        align-content: flex-start;
    }
}
</style>
